/*
 * Empowers the submenu on the U1 template. Submenu
 * scroll the content section to the associated paragraph
 *
 * @author BarrelNY
 *
 */

var Map = {
	init:function(){

		//What templates should trigger this module?
		var templates = [
			'body.neighborhood-template'
		].join();

		if (!$(templates).length) return;

		this.$icons   = $('[data-coordinates]');
		this.$filters = $('.filters li');
		this.$enlarge = $('.enlarge').addClass('show');
		this.$titles  = $('.list h4');

		if (
			!Modernizr.csscolumns &&
			!MUR.isSmall('md') &&
			$.fn.columnize
		){
			$('.list .inner').columnize({ columns: 3 });
		}

		this.events();
		this.setIcons();
		this.setScrollPosition();
		this.setupMobileUI();
	},

	events:function(){
		this.$filters.on('click', this.filter.bind(this) );
		this.$enlarge.on('click', this.viewAll.bind(this) );
		this.$titles.on('click', this.toggleLists.bind(this) );
		this.$icons.on('touchstart', this.toggleTitle.bind(this) );

		$(window)
			.resize( this.setupMobileUI.bind(this) );
	},

	/*
	 * Just an interator function
	 *
	 */
	setIcons:function(){
		this.$icons
		.each(this.interpretCoordinates);

		this.revealAll();
	},

	/*
	 * Start the map somwhere in the middle
	 * rather than top left (aim: see 111murray)
	 *
	 */
	setScrollPosition:function(){
		var
			$el = $('.min-width'),
			wh  = $(window).height(),
			dh  = $el.height(),
			_x  = (wh - dh) / 1.3; //Approx. number (no science)

		if ( _x < 0 ){
			$('.map-overflow').stop().animate({scrollLeft: Math.abs(_x) }, 1);
		}
	},

	setupMobileUI:function(){
		if ( !MUR.isSmall('md') ){

			if (typeof this.F != 'undefined'){
				this.F.destroy();
				delete this.F;
			}

		} else if ( !this.F ){

			var $ul = this.$filters.parent();

			this.F = new Flickity($ul[0],{
				contain:true,
				draggable:true,
				pageDots:false,
				wrapAround:true,
				prevNextButtons:true,
				touchVerticalScroll: false
			});

			this.F.on( 'settle', this.filter.bind(this) );

		}

		//Retuns undefined if panzoom has not been enabled
		var PZexists = $(".pan-zoom").panzoom("instance");

		//Panzoom doesn't exist and it should
		if (
			!PZexists
		){

			//Default
			var startTransform = 'matrix(1, 0, 0, 1, -104, -429)';

			if ( MUR.isSmall('ipad') ){
				startTransform = 'matrix(1.3441347008451356, 0, 0, 1.3441347008451356, -176.19696683270945, -408.29343697655565)';
			}

			if ( MUR.isSmall('md') ){
				startTransform = 'matrix(1.2377663842087994, 0, 0, 1.2377663842087994, -344.74165652554075, -340.29313060388813)';
			}

			if ( MUR.isSmall('sm') ){
				startTransform = 'matrix(1.6666012941961887, 0, 0, 1.6666012941961887, -318.3727752577863, -301.72801475990445)';
			}

			var $pz = $(".pan-zoom");

			//This is weird. If we are moving from a fullpage
			//Scroll website to panzoom, the css transform prefix
			//(as well as a bunch more) is set to "Ms", rather
			//Than the needed Webkit, for Webkit devices. Thus,
			//Panzoom breaks. This has got to be a bug with
			//Fullpage.js. Anyhow, here we set it back to the way
			//it should be..
			if ( 'WebkitTransform' in $pz[0].style)
				$.cssProps.transform = 'WebkitTransform';

			$pz.panzoom({
				contain: 'invert',
				minScale: 1,
				startTransform: startTransform
			}).on(
				'touchstart',this.toggleTitle
			)

		//Panzoom does exist and it shouldn't
		} else {
			$(".pan-zoom").panzoom("resetDimensions");
			$(".pan-zoom").panzoom("reset");
		}
	},

	toggleTitle:function(e){
		e.stopPropagation();

		var
			c = e.currentTarget,
			$el = !$(c).hasClass('pan-zoom') ?
				$(c).addClass('show-title') : '.not-a-class';

		$('.show-title').not($el).removeClass('show-title');
	},

	/*
	 * Mobile list view toggle
	 *
	 */
	toggleLists:function(e){
		if ( !MUR.isSmall('md') )
			return;

		var
			$el = $(e.currentTarget),
			$ul = $el.next();

		this.$titles.not($el).removeClass('active');
		$el.addClass('active');

		$('.list ul').not($ul).slideUp(800,function(){
			$(this).attr('style','');
		});

		$ul.slideDown(800);
	},

	/*
	 * Show the entire map
	 *
	 * @returns bool  false stop propagation, prevent default
	 *
	 */
	viewAll:function(e){
		$(e.currentTarget).fadeOut(500);
		$('.map').addClass('show-all');
		$('.section-map').addClass('show-all');

		return false;
	},

	/*
	 * Called on init after icon positions have been set
	 *
	 */
	revealAll:function(){
		var
			_ = this,
			filterTypes = Array(),
			delay = 2;

		if (Modernizr.touch){
			this.revealAllMobile();
			return;
		}

		//Get all the diff types of filters
		this.$filters.each(function(i){
			filterTypes[i] = $(this).data('filter');
		});

		//Stagger the fade in animation
		$.each(filterTypes,function(i){
			$this = $('[data-filter="'+ this +'"]');

			if (this == 0){
				$this = $this.add( $('[data-group-location]') );
			}

			TweenMax.to($this, 2,
				{
					scale:1,
					opacity:1,
					delay:delay,
					clearProps:'transform,opacity',
					onComplete:function($el){
						$el.addClass('show');

						setTimeout(function(){
							$el.addClass('transition');
						},0.2);

						_.registerAnimationEnd();

					}.bind(this,$this)
				}
			);
			delay += 0.2;
		});
	},

	revealAllMobile:function(){
		$('[data-filter]').addClass('show').addClass('transition');
		this.registerAnimationEnd();
	},

	/*
	 * Assess if the intro animation is over
	 *
	 */
	registerAnimationEnd:function(){
		var $notvisible = this.$filters.not('.show');

		if ( !$notvisible.count ){
			this.$filters.parent().addClass('show-all');
			this.revealComplete = true;
		}

	},

	/*
	 * Show/hide certain types of markers
	 *
	 */
	filter:function(e){
		if ( !this.revealComplete )
			return;

		var
			_ = this,
			$ul = this.$filters.parent(),
			el;

		if (typeof e == 'undefined'){

			if ( typeof this.F != 'undefined'){
				el = this.F.selectedElement;
			} else {
				el = this.$filters.eq(0);
			}

		} else {
			el = e.currentTarget;
		}

		filter = $(el).data('filter');

		this.$filters.not(el).removeClass('active');
		$(el).addClass('active');

		if ( filter == 0){
			$('[data-filter]').add('[data-group-location]').addClass('show');
			return;
		}

		var $add = filter == 'shopping' ?
			$('[data-group-location]') :
				$('.dummy-element');

		$show = this.$icons.filter('[data-filter="'+filter+'"]').add($add).addClass('show');
		this.$icons.not($show).removeClass('show');
	},

	/*
	 * Take a string that is received from CMS
	 * and convert into CSS properties
	 *
	 */
	interpretCoordinates:function(){
		var coordinates = $(this).attr('data-coordinates').split(',');
		$(this).css(
			{
				left: coordinates[0] + '%',
				top: coordinates[1] + '%'
			}
		).addClass('place-set');
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		this.revealComplete = false;

		if (this.F)
			delete this.F;

	}
}

module.exports = Map;
